import { atom, useAtom } from 'jotai';
import { User } from '../components/dashboard/admin/users/types/user.types';
import { Permissions } from '../permissions/permissions';

// Create the loggedin user atom
export const userAtom = atom<User | null>(null);

// Custom hook for active user management
export const useAuthUser = () => {
  const [activeUser, setActiveUser] = useAtom(userAtom);

  const clearActiveUser = () => setActiveUser(null);

  const getUserPermissions = (): Permissions | null => {
    return activeUser?.role?.permissions || null;
  };

  const isSysAdmin = (): boolean => {
    return activeUser?.isSysAdmin ?? false;
  };

  return { activeUser, setActiveUser, clearActiveUser, getUserPermissions, isSysAdmin };
};
